// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  arrayUnion,
} from "firebase/firestore";
import {
  createUserWithEmailAndPassword,
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  updateProfile,
  signInAnonymously,
  signInWithEmailAndPassword,
} from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCld-yUDgkz1OD_qRkmWNNdODYiY3M6zr4",
  authDomain: "ambaarijewels-8f525.firebaseapp.com",
  projectId: "ambaarijewels-8f525",
  storageBucket: "ambaarijewels-8f525.firebasestorage.app",
  messagingSenderId: "710285686087",
  appId: "1:710285686087:web:7e0996887ff47118760862",
  measurementId: "G-P8L6FLRXCZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
